"use strict";
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _construct(Parent, args, Class) {
    if (_is_native_reflect_construct()) {
        _construct = Reflect.construct;
    } else {
        _construct = function construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _set_prototype_of(instance, Class.prototype);
            return instance;
        };
    }
    return _construct.apply(null, arguments);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function wrapNativeSuper(Class) {
        if (Class === null || !_is_native_function(Class)) return Class;
        if (typeof Class !== "function") {
            throw new TypeError("Super expression must either be null or a function");
        }
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return _construct(Class, arguments, _get_prototype_of(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return _set_prototype_of(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pinoApplicationInsightsLogHandler = void 0;
var _applicationinsightsWeb = require("@microsoft/applicationinsights-web");
var _pinoStdSerializers = _interopRequireDefault(require("pino-std-serializers"));
var _applicationInsights = require("../../application-insights");
var _definePinoLogHandlers = require("./definePinoLogHandlers");
/* eslint-disable @typescript-eslint/naming-convention -- thats how AI defines it */ /**
 * This is error that acts as a "copy" of the original error as it overrides
 * its own properties with the original values
 */ var DeserializedError = /*#__PURE__*/ function(Error1) {
    _inherits(DeserializedError, Error1);
    function DeserializedError(name, message, stack) {
        _class_call_check(this, DeserializedError);
        var _this;
        _this = _call_super(this, DeserializedError, [
            message
        ]);
        // eslint-disable-next-line unicorn/custom-error-definition -- we want everything from the original error, including name
        _this.name = name;
        _this.stack = stack;
        return _this;
    }
    return DeserializedError;
}(_wrap_native_super(Error));
var getServerApplicationInsightsTagOverrides = function(operation) {
    return operation ? {
        'ai.operation.id': operation.id,
        'ai.operation.name': operation.name,
        'ai.operation.parentId': operation.parentId
    } : undefined;
};
var pinoApplicationInsightsLogHandler = exports.pinoApplicationInsightsLogHandler = (0, _definePinoLogHandlers.definePinoLogHandlers)({
    onError: function(message) {
        var serializedOrNormalError = message.error, time = message.time, msg = message.msg, applicationInsightsOperation = message.applicationInsightsOperation, otherMessageProperties = _object_without_properties(message, [
            "error",
            "time",
            "msg",
            "applicationInsightsOperation"
        ]);
        var ai = _applicationInsights.ApplicationInsights.get();
        // First we need to make sure that every error is first serialized into object
        // In environment with workers this is usually done through pino, but in browser the error is as is
        var _ref = serializedOrNormalError instanceof Error ? _pinoStdSerializers.default.errWithCause(serializedOrNormalError) : serializedOrNormalError, errorName = _ref.type, errorMessage = _ref.message, errorStack = _ref.stack, errorCause = _ref.cause, otherProperties = _object_without_properties(_ref, [
            "type",
            "message",
            "stack",
            "cause"
        ]);
        var properties = otherMessageProperties;
        if (Object.keys(otherProperties).length > 0) {
            // Attach otherProperties (anything than normal Error.prototype fields) as customDimensions
            // as those would be destroyed in application insights library
            properties.errorProperties = otherProperties;
        }
        // If error has cause we need to prepare it also. We cannot reasonably do this anything than
        // setting that cause as customDimensions data, because Application Insights do not support that
        if (errorCause) {
            var causeName = errorCause.type, causeMessage = errorCause.message, causeStack = errorCause.stack, otherCauseProperties = _object_without_properties(errorCause, [
                "type",
                "message",
                "stack"
            ]);
            properties.cause = _object_spread({
                name: causeName,
                message: causeMessage,
                // This could be enhanced with further parsing
                // just do it like in application insights library https://github.com/microsoft/ApplicationInsights-node.js/blob/b5b173648f095c8cea7dcf414521ab5b9fe12ab6/src/logs/exceptions.ts#L127
                stack: causeStack
            }, Object.keys(otherCauseProperties).length > 0 ? {
                errorProperties: otherCauseProperties
            } : null);
        }
        // Lastly we create a "copy" of the original error for application insights
        var exception = new DeserializedError(errorName, errorMessage, errorStack);
        if ((0, _applicationInsights.isServerApplicationInsightsClient)(ai)) {
            ai.defaultClient.trackException({
                exception: exception,
                time: new Date(time),
                severity: ai.Contracts.SeverityLevel.Error,
                properties: properties,
                tagOverrides: getServerApplicationInsightsTagOverrides(applicationInsightsOperation)
            });
        } else {
            ai.trackException({
                exception: exception,
                properties: properties
            });
        }
    },
    // Lets leave this on here for the future
    // onInfo(message) {
    //   const ai = getApplicationInsights();
    //   const { msg, time, ...otherProperties } = message;
    //   const params = {
    //     message: `${msg} ${Object.entries(otherProperties)
    //       .map(([key, value]) => `${key}: ${JSON.stringify(value)}`)
    //       .join(', ')}`,
    //     properties: otherProperties,
    //   };
    //   if (isServerApplicationInsightsClient(ai)) {
    //     ai.defaultClient.trackTrace({
    //       ...params,
    //       time: new Date(time),
    //       severity: ai.Contracts.SeverityLevel.Information,
    //     });
    //   } else {
    //     ai.trackTrace({
    //       ...params,
    //       severityLevel: SeverityLevel.Information,
    //     });
    //   }
    // },
    onMetric: function(message) {
        var metricName = message.metricName, metricValue = message.metricValue, time = message.time, applicationInsightsOperation = message.applicationInsightsOperation, otherMesageProperties = _object_without_properties(message, [
            "metricName",
            "metricValue",
            "time",
            "applicationInsightsOperation"
        ]);
        var ai = _applicationInsights.ApplicationInsights.get();
        if ((0, _applicationInsights.isServerApplicationInsightsClient)(ai)) {
            ai.defaultClient.trackMetric({
                name: metricName,
                value: metricValue,
                time: new Date(time),
                properties: otherMesageProperties,
                tagOverrides: getServerApplicationInsightsTagOverrides(applicationInsightsOperation)
            });
        } else {
            ai.trackMetric({
                name: metricName,
                average: metricValue,
                properties: otherMesageProperties
            });
        }
    },
    onWarn: function(message) {
        var _message_msg = message.msg, msg = _message_msg === void 0 ? '' : _message_msg, time = message.time, applicationInsightsOperation = message.applicationInsightsOperation, otherProperties = _object_without_properties(message, [
            "msg",
            "time",
            "applicationInsightsOperation"
        ]);
        var ai = _applicationInsights.ApplicationInsights.get();
        if ((0, _applicationInsights.isServerApplicationInsightsClient)(ai)) {
            ai.defaultClient.trackTrace({
                message: msg,
                time: new Date(time),
                severity: ai.Contracts.SeverityLevel.Warning,
                properties: otherProperties,
                tagOverrides: getServerApplicationInsightsTagOverrides(applicationInsightsOperation)
            });
        } else {
            ai.trackTrace({
                message: msg,
                severityLevel: _applicationinsightsWeb.SeverityLevel.Warning,
                properties: otherProperties
            });
        }
    }
}); //# sourceMappingURL=pinoApplicationInsightsLogHandler.js.map
